import request from '@/utils/request';
import Vue from 'vue';

export function getSolution(params) {
  return request({
    url: Vue.prototype.$api.solution.find,
    method: 'get',
    params,
  });
}

export function getRecommand(params) {
  return request({
    url: Vue.prototype.$api.solution.recommand,
    method: 'get',
    params,
  });
}

export function getSolutionDetail(params) {
  return request({
    url: Vue.prototype.$api.solution.detail,
    method: 'get',
    params,
  });
}

export function getGoodsList(params) {
  return request({
    url: Vue.prototype.$api.solution.goodIndex,
    method: 'get',
    params,
  });
}

export function getCategoryList(params) {
  console.log(params);
  return request({
    url: Vue.prototype.$api.solution.category,
    method: 'get',
    params,
  });
}

export function getRecommend(params) {
  return request({
    url: 'api/solution/recommend',
    method: 'get',
    params,
  });
}

export function getFinancial(params) {
  return request({
    url: 'api/financial.service/index',
    method: 'get',
    params,
  });
}

export function getScheme(params) {
  return request({
    url: 'api/solution/index',
    method: 'get',
    params,
  });
}



// WEBPACK FOOTER //
// ./src/api/tool/solution.js